import type { FormikHelpers } from 'formik';
import React, { useState } from 'react';
import Button from '../../components/Button';
import Card from '../../components/Card';
import CardHeader from '../../components/CardHeader';
import Caret from '../../components/Caret';
import Form, { Field, Submit } from '../../components/Form';
import * as styles from './RequestIntegration.module.scss';
import useRequestIntegrationMutation from './useRequestIntegrationMutation';

interface RequestIntegrationProps {
  intialExpanded?: boolean;
}

type Values = {
  name: string;
  website: string;
  detail: string;
};

const RequestIntegration = ({ intialExpanded }: RequestIntegrationProps) => {
  const [isExpanded, setIsExpaded] = useState(intialExpanded);

  const request = useRequestIntegrationMutation();

  const onSubmit = async (
    values: Values,
    { resetForm }: FormikHelpers<Values>,
  ) => {
    const isRequested = await request(
      values.name,
      values.website,
      values.detail,
    );
    if (isRequested) {
      resetForm();
    }
  };

  return (
    <Card>
      <CardHeader
        title="Request a new integration"
        meta="Help us prioritize our next integration"
        rightAction={
          <Button variant="link" onClick={() => setIsExpaded((exp) => !exp)}>
            Make a request <Caret direction={isExpanded ? 'up' : 'down'} />
          </Button>
        }
      />
      {isExpanded && (
        <Form<Values>
          onSubmit={onSubmit}
          initialValues={{ name: '', website: '', detail: '' }}
        >
          <Field
            className={styles.form}
            required
            label="Name of integration"
            type="text"
            name="name"
            placeholder="Google"
          />
          <Field
            required
            type="text"
            name="website"
            label="Website"
            placeholder="https://google.com"
          />
          <Field
            required
            label="Use case"
            type="textarea"
            name="detail"
            placeholder="How you’d like to use this integration"
          />
          <div className={styles.submit}>
            <Submit>Submit</Submit>
          </div>
        </Form>
      )}
    </Card>
  );
};

export default RequestIntegration;
